import { c as _c } from "react/compiler-runtime";
import { DOCS__READING_STATUS } from '@algoacademy/backend/modules/docs/enums';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { cn } from '@/app/_lib/utils';
import type { ARTICLE_STATE } from '@/app/baza/(collection)/_utils/ArticleStateContext/types';
type ArticleStatusIconProps = {
  status?: ARTICLE_STATE;
  isCurrent: boolean;
};
export function ArticleStatusIcon(t0) {
  const $ = _c(16);
  const {
    status,
    isCurrent
  } = t0;
  const t1 = status === DOCS__READING_STATUS.READ || status === DOCS__READING_STATUS.WANT_TO_READ ? "m-0 mt-0.5 h-5 w-5 border-none" : isCurrent ? "border-contentColorPrimary" : "border-contentSecondary";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("m-0.5 mt-1 h-4 w-4 flex-shrink-0 overflow-hidden rounded-full border-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isCurrent || $[3] !== status) {
    t3 = status === DOCS__READING_STATUS.READ && <CheckCircleIcon className={cn("h-5 w-5 flex-shrink-0", isCurrent ? "text-contentBlue" : "text-contentSecondary")} />;
    $[2] = isCurrent;
    $[3] = status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isCurrent || $[6] !== status) {
    t4 = status === DOCS__READING_STATUS.IN_PROGRESS && <div className={cn("h-full w-1/2", isCurrent ? "bg-contentColorPrimary" : "bg-contentSecondary")} />;
    $[5] = isCurrent;
    $[6] = status;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isCurrent || $[9] !== status) {
    t5 = status === DOCS__READING_STATUS.WANT_TO_READ && <PlusCircleIcon className={cn("h-5 w-5 flex-shrink-0", isCurrent ? "text-contentBlue" : "text-contentSecondary")} />;
    $[8] = isCurrent;
    $[9] = status;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}